import { render, staticRenderFns } from "./RequestSend.vue?vue&type=template&id=163857ed"
import script from "./RequestSend.vue?vue&type=script&lang=js"
export * from "./RequestSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports